import { useEffect, useRef, useState } from "react";

export const useDragableAndResizer = (
  initialPositionX,
  initialPositiony,
  signalToResetPosition,
  minWidthInPixel,
  minHeightPercent
) => {
  const [position, setPosition] = useState({
    x: initialPositionX,
    y: initialPositiony,
  });
  const [size, setSize] = useState({ w: 200, h: 200 });

  const isDragging = useRef(false);
  const isResizing = useRef(false);
  const initialMousePos = useRef({ x: 0, y: 0 });
  const initialDims = useRef({ w: 0, h: 0, x: 0, y: 0 });

  const handleMouseDownDrag = (e) => {
    try {
      // Impede o arraste se clicarmos no puxador de redimensionamento
      if (e.target.className.includes("resizer")) return;

      isDragging.current = true;
      initialMousePos.current = { x: e.clientX, y: e.clientY };
      initialDims.current = { x: position.x, y: position.y };

      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    } catch (error) {}
  };

  // --- LÓGICA DE REDIMENSIONAR (RESIZE) ---
  // const handleMouseDownResize = (e) => {
  //   // Para a propagação para evitar ativar o evento de arraste do pai
  //   e.stopPropagation();

  //   isResizing.current = true;
  //   initialMousePos.current = { x: e.clientX, y: e.clientY };
  //   initialDims.current = { w: size.w, h: size.h };

  //   document.addEventListener("mousemove", handleMouseMove);
  //   document.addEventListener("mouseup", handleMouseUp);
  // };

  const handleMouseMove = (e) => {
    const deltaX = e.clientX - initialMousePos.current.x;
    const deltaY = e.clientY - initialMousePos.current.y;

    if (isDragging.current) {
      // Atualiza posição
      setPosition({
        x: initialDims.current.x + deltaX,
        y: initialDims.current.y + deltaY,
      });
    } else if (isResizing.current) {
      const viewportHeight = window.innerHeight;

      // 2. Converte a porcentagem desejada em pixels
      const minWPixel = minWidthInPixel;
      const minHPixel = (viewportHeight * minHeightPercent) / 100;

      setSize({
        w: Math.max(minWPixel, initialDims.current.w + deltaX),
        h: Math.max(minHPixel, initialDims.current.h + deltaY),
      });
    }
  };

  const handleMouseUp = () => {
    isDragging.current = false;
    isResizing.current = false;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  useEffect(() => {
    setPosition({ x: initialPositionX, y: initialPositiony });
  }, [signalToResetPosition]);

  useEffect(() => {
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  return {
    position,
    size,
    handleMouseDownDrag,
    handleMouseMove,
    handleMouseUp,
  };
};
